import { SelectionDropdown } from "@libs/zapi-ui/custom";
import { SOURCE_OPTIONS } from "../const/const";

type TSourceSelectProps = {
  source: string;
  setSource: (source: string) => void;
};

export function SourceSelect({ source, setSource }: TSourceSelectProps) {
  return (
    <div className="space-y-2 w-[180px]">
      <SelectionDropdown
        placeholder="All Sources"
        options={SOURCE_OPTIONS}
        value={source}
        onChange={(v) => {
          setSource(v);
        }}
        className="rounded-[8px]"
      />
    </div>
  );
}
